import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Container, Grid, Typography } from '@material-ui/core';

import Icon from '../../../assets/images/results-time.png';

import { round } from '../../utils/number';
import { displayHrs, displayHoursMinutes } from '../../utils/display';
import Breakdown from './Breakdown';
import Chart from './Chart';

const useStyles = makeStyles(theme => ({
  gridContainer: {
    paddingBottom: 120,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center'
    }
  },
  icon: {
    marginBottom: 16
  },
  heading: {
    marginBottom: 12
  },
  time: {
    marginBottom: 60
  },
  infoWrapper: {
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center'
    },
  },
  chartWrapper: {
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginTop: 60
    },
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: theme.palette.grey[100],
    minWidth: 260,
    maxWidth: 400,
    padding: theme.spacing(5, 0)
  }
}));

export default function Cost(props) {
  const {
    timePerYear,
    timePerMonth,
    timePerWeek,
    timePerRAMS,
    roles
  } = props;

  const classes = useStyles();

  const chartData = roles.map(role => {
    role['timePerYear'] = round(role['timePerYear'])
    return role
  });

  return (
    <Container maxWidth='lg'>
      <Grid
        container
        className={classes.gridContainer}
        direction='row'
        justify='space-between'
      >
        <Grid item className={classes.infoWrapper}>
          <img className={classes.icon} src={Icon} alt='results-time' height={48} />
          <Typography className={classes.heading} variant='subtitle1' component='h3'>Each year, RAMS are costing your business</Typography>
          <Typography className={classes.time} variant='h1' component='div'>{displayHrs(round(timePerYear))}</Typography>
          <Breakdown value={round(timePerMonth)} display={displayHoursMinutes} period='per month' />
          <Breakdown value={round(timePerWeek)} display={displayHoursMinutes} period='per week' />
          <Breakdown value={round(timePerRAMS, 2)} display={displayHoursMinutes} period='per RAMS' />
        </Grid>
        <Grid item className={classes.chartWrapper}>
          <Chart
            total={round(timePerYear)}
            colors={['#8984D8', '#0088FF', '#20BBA5', '#DD4938']}
            display={displayHrs}
            data={chartData}
            dataKey='timePerYear'
          />
        </Grid>
      </Grid>
    </Container>
  )
}
